var React = require('react');

function Message (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.5 5C12.1488 5 7.00004 10.1487 7.00004 16.5C7.00004 18.9791 7.78278 21.2709 9.11475 23.1476C9.41339 23.5683 9.4748 24.1131 9.27735 24.5898L7.77125 28.2258L11.7739 26.5689C12.1902 26.3966 12.6618 26.4205 13.0585 26.634C14.677 27.5051 16.5285 28 18.5 28C24.8513 28 30 22.8513 30 16.5C30 10.1487 24.8513 5 18.5 5ZM4.00004 16.5C4.00004 8.49187 10.4919 2 18.5 2C26.5082 2 33 8.49187 33 16.5C33 24.5081 26.5082 31 18.5 31C16.2785 31 14.1704 30.4994 12.2854 29.6041L5.57376 32.3824C5.01326 32.6144 4.36817 32.486 3.93927 32.057C3.51036 31.628 3.38208 30.9828 3.61422 30.4224L6.19951 24.181C4.80583 21.9532 4.00004 19.3189 4.00004 16.5Z","fill":"#153E67"}));
}

Message.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Message;

Message.default = Message;
